/* tslint:disable */
/* eslint-disable */
export enum BusinessAddressType {
  BUSINESS = 'BUSINESS',
  MAILING = 'MAILING',
  OFFICE = 'OFFICE'
}
